import React from "react";

const About = () => {
  return <div>comming soon...</div>;
};

export default About;
